import React from "react";
import { connect } from "react-redux";
import User from "../components/System/User";

function UserPage({ accessToken, currentLang }) {
  return <User accessToken={accessToken} currentLang={currentLang} />;
}

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(UserPage);
